import type { PropsWithChildren, ReactNode } from 'react';

import onboardingBackgroundImage from '@/assets/icons/strev/onboarding-background-image.png';
import { BrandMark } from '@/components/layout/white-label/BrandMark';
import { useTheme } from '@/providers/ThemeProvider';
import { cn } from '@/utils/cn';
import '@/components/layout/onboarding.scss';

type OnboardingProps = PropsWithChildren<{
  eyebrow?: string;
  title: string;
  description?: string;
  descriptionClassName?: string;
  aside?: ReactNode;
}>;

export function Onboarding({
  eyebrow,
  title,
  description,
  descriptionClassName,
  aside,
  children,
}: OnboardingProps) {
  const theme = useTheme();
  const hasHeroCopy = Boolean(eyebrow || title || description || aside);

  return (
    <div className="auth-shell">
      <img src={onboardingBackgroundImage} alt="" aria-hidden="true" className="auth-shell__background" />
      <div className="auth-shell__background-overlay" aria-hidden="true" />

      <section className="auth-shell__panel auth-shell__panel--card auth-shell__panel--full">
        {theme.logos.login ? (
          <img src={theme.logos.login} alt={`${theme.brandName} logo`} className="auth-shell__logo" />
        ) : (
          <BrandMark />
        )}

        {hasHeroCopy ? (
          <div className="auth-shell__hero-copy">
            {eyebrow ? <span className="auth-shell__eyebrow">{eyebrow}</span> : null}
            {title ? <h1 className="auth-shell__title">{title}</h1> : null}
            {description ? <p className={cn('auth-shell__description', descriptionClassName)}>{description}</p> : null}
            {aside}
          </div>
        ) : null}

        <div className="auth-shell__card-wrap">{children}</div>
      </section>
    </div>
  );
}
